(() => {
  const init = (scope = document) => {
    scope.querySelectorAll('[data-bm-footer]').forEach((root) => {
      if (root.dataset.bmFooterReady === 'true') return;
      root.dataset.bmFooterReady = 'true';

      const dialog = root.querySelector('[data-bm-cookie-dialog]');
      const open = root.querySelector('[data-bm-cookie-open]');
      const save = root.querySelector('[data-bm-cookie-save]');
      const reject = root.querySelector('[data-bm-cookie-reject]');
      const status = root.querySelector('[data-bm-cookie-status]');
      const preferences = root.querySelector('[data-bm-cookie-preferences]');
      const analytics = root.querySelector('[data-bm-cookie-analytics]');
      const marketing = root.querySelector('[data-bm-cookie-marketing]');

      if (!dialog || !open) return;

      const message = (text) => {
        if (status) status.textContent = text;
      };

      const unavailable =
        root.dataset.cookieUnavailable ||
        'Cookie-instellingen konden niet worden geladen. Probeer het opnieuw.';
      const saved =
        root.dataset.cookieSaved ||
        'Je cookievoorkeuren zijn opgeslagen.';

      const withApi = (callback) => {
        if (window.Shopify?.customerPrivacy) {
          callback(window.Shopify.customerPrivacy);
          return;
        }

        if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
          window.Shopify.loadFeatures(
            [{ name: 'consent-tracking-api', version: '0.1' }],
            (error) => {
              if (!error && window.Shopify?.customerPrivacy) callback(window.Shopify.customerPrivacy);
              else message(unavailable);
            }
          );
          return;
        }

        message(unavailable);
      };

      const sync = (api) => {
        const current = typeof api.currentVisitorConsent === 'function'
          ? api.currentVisitorConsent()
          : {};

        if (preferences) preferences.checked = current.preferences === 'yes';
        if (analytics) analytics.checked = current.analytics === 'yes';
        if (marketing) marketing.checked = current.marketing === 'yes';
      };

      const close = () => {
        if (typeof dialog.close === 'function') dialog.close();
        else dialog.removeAttribute('open');
      };

      const persist = (value, source) => {
        withApi((api) => {
          api.setTrackingConsent(value, () => {
            message(saved);
            document.dispatchEvent(new CustomEvent('bm:cookie-consent-resolved', {
              detail: {
                source,
                consent: typeof api.currentVisitorConsent === 'function'
                  ? api.currentVisitorConsent()
                  : {}
              }
            }));
            window.setTimeout(close, 650);
          });
        });
      };

      open.addEventListener('click', () => {
        message('');
        if (typeof dialog.showModal === 'function') dialog.showModal();
        else dialog.setAttribute('open', '');
        withApi(sync);
      });

      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) close();
      });

      save?.addEventListener('click', () => {
        persist({
          preferences: Boolean(preferences?.checked),
          analytics: Boolean(analytics?.checked),
          marketing: Boolean(marketing?.checked)
        }, 'settings-save');
      });

      reject?.addEventListener('click', () => {
        if (preferences) preferences.checked = false;
        if (analytics) analytics.checked = false;
        if (marketing) marketing.checked = false;

        persist({
          preferences: false,
          analytics: false,
          marketing: false
        }, 'settings-essential-only');
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
